import angular from 'angular';
import eventsComponent from './events.component';

const eventsModule = angular.module('events', [
])
  .component('events', eventsComponent)
  .name;

export default eventsModule;
